import { render, staticRenderFns } from "./CustomPageCardSkeleton.vue?vue&type=template&id=1f52de30&"
import script from "./CustomPageCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CustomPageCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports